import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ClusterData } from '../types';

import { CLUSTERS } from 'RestAPIs/endpoints';
import { useSaveResource } from 'RestAPIs/useSaveResource';

import { LoadingButton } from '@mui/lab';

import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';

import { clustersSchema } from '../schema';
import BaseClusterSection from './BaseSection';

type Props = {
  currentData?: ClusterData;
  handleClose: () => void;
};

const ClusterForm = ({ currentData, handleClose }: Props) => {
  const { t } = useTranslation('common');
  const { mutateAsync: saveForm, isLoading } = useSaveResource({
    url: CLUSTERS,
    id: currentData?.clusterId,
    invalidateQueryKey: ['clusters']
  });

  const methods = useForm<ClusterData>({
    defaultValues: clustersSchema(t).cast(currentData),
    resolver: yupResolver(clustersSchema(t))
  });

  const { control, handleSubmit } = methods;

  const onSubmit = async (data: ClusterData) => {
    await saveForm(data).then(handleClose);
  };

  return (
    <MultiStepForm methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <BaseClusterSection control={control} />
      <MultiStepForm.Actions>
        <LoadingButton
          loading={isLoading}
          type="submit"
          variant="contained"
          autoFocus
          color="dark"
        >
          {t('save')}
        </LoadingButton>
      </MultiStepForm.Actions>
    </MultiStepForm>
  );
};

export default ClusterForm;
